import { Guid } from "@/types"
import { AssetShippingStatus } from "./ShippingOrderAsset"

export interface IGetShippingOrderCartAssetDto {
    assetId: Guid
    status: AssetShippingStatus
    departureLocationId?: Guid | null
    arrivalLocationId?: Guid | null
    transportId?: Guid | null
}

export interface IUpdateShippingOrderCartAssetDto {
    assetIds: Guid[]
    transportId?: Guid | null
    transportSequence?: number | null
    departureLocationId?: Guid | null
    arrivalLocationId?: Guid | null
}

export default class ShippingOrderCartAsset {
    assetId: Guid
    status: AssetShippingStatus
    departureLocationId?: Guid
    arrivalLocationId?: Guid
    transportId?: Guid
    sequence?: number

    constructor(dto: IGetShippingOrderCartAssetDto, sequence?: number) {
        this.assetId = dto.assetId
        this.status = dto.status
        this.departureLocationId = dto.departureLocationId || undefined
        this.arrivalLocationId = dto.arrivalLocationId || undefined
        this.transportId = dto.transportId || undefined
        this.sequence = sequence
    }

    get isInTransport() {
        return !!this.transportId
    }
}
